"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerCreditDataDelayedPaymentToJSON = exports.CustomerCreditDataDelayedPaymentFromJSONTyped = exports.CustomerCreditDataDelayedPaymentFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function CustomerCreditDataDelayedPaymentFromJSON(json) {
    return CustomerCreditDataDelayedPaymentFromJSONTyped(json, false);
}
exports.CustomerCreditDataDelayedPaymentFromJSON = CustomerCreditDataDelayedPaymentFromJSON;
function CustomerCreditDataDelayedPaymentFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'entries': !(0, runtime_1.exists)(json, 'entries') ? undefined : (json['entries'].map(_1.CustomerCreditDataDelayedPaymentEntriesFromJSON)),
    };
}
exports.CustomerCreditDataDelayedPaymentFromJSONTyped = CustomerCreditDataDelayedPaymentFromJSONTyped;
function CustomerCreditDataDelayedPaymentToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'entries': value.entries === undefined ? undefined : (value.entries.map(_1.CustomerCreditDataDelayedPaymentEntriesToJSON)),
    };
}
exports.CustomerCreditDataDelayedPaymentToJSON = CustomerCreditDataDelayedPaymentToJSON;
//# sourceMappingURL=CustomerCreditDataDelayedPayment.js.map